import React from "react";
import { AppContext } from "../../../contexts/AppContext";

function ConteudoEsquerda() {
  const { baseUrl } = React.useContext(AppContext);

  return (
    <div className="col-xl-9">
      <div className="auth-full-bg pt-lg-5 p-4">
        <div className="w-100">
          <div className="d-flex h-100 flex-column">
            <div className="p-1 mt-auto text-center-left">
              <div className="row justify-content-center">
                <div
                  className="col-9 col-sm-9 col-lg-5 col-md-5 col-xl-7 col-xxl-5"
                  style={{ zIndex: 1 }}
                >
                  <div className="text-left">
                    <div dir="ltr">
                      <div className="item">
                        <div className="py-4">
                          <img
                            src={`${baseUrl}assets/images/logos/logo_branca.svg`}
                            className="logo-branca"
                            alt="logo"
                          />
                          <p className="center-text">
                            Uma <br className="br1" />
                            contabilidade <br />
                            moderninha <br className="br1" />
                            pensada <br className="br2" /> em você.{" "}
                            <br className="br1" />
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-auto" style={{ zIndex: 1 }}>
              <div className="row justify-content-center">
                <div className="col-lg-8">
                  <div className="text-center">
                    <div dir="ltr">
                      <div className="item">
                        <div className="py-1">
                          <p className="font-size-12 left-footer">
                            A Orangiuz é uma startup de soluções contábeis.
                            Ajudamos empresas de tecnologia
                            <br />a crescerem sem as travas da contabilidade
                            tradicional. #SejaUmOranger
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="auth-full-bg-img">
        <div className="d-flex h-100 flex-column father-image">
          <div className="p-12 image-inside">
            <img
              src={`${baseUrl}assets/images/background/mascote.svg`}
              className="image-inside"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default ConteudoEsquerda;
